module.exports = __webpack_public_path__ + "img/img_body_biz_tomorrownet_logo.c34b0219.png";